import { BrowseMode } from '../../models/browse-mode';

export class ModeState {
  modes: BrowseMode[] = [];
  selectedMode!: BrowseMode;
}
